const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  noticeNumber: state => state.app.noticeNumber,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  errorLogs: state => state.errorLog.logs,
  menus: state => state.permission.menus,
  pageData: state => state.page.pageData,
  userId: state => state.user.userId,
  lang: state => state.app.lang,
  langMessages: state => state.app.langMessages,
  timeZone: state => state.app.timeZone,
}
export default getters
